module.exports = __webpack_public_path__ + "static/pic02-bfdf8e9ef31d1627edb279b741ead5f7.jpg";